export class DigitalAssetsUploadComponent {
  #componentSelector;

  #filesListClasName = "digital-assets-assets-upload-form--empty-files";

  constructor(options) {
    this.#componentSelector = options.componentSelector;
  }

  get $component() {
    return document.querySelector(this.#componentSelector);
  }

  showFilesList() {
    this.$component.classList.remove(this.#filesListClasName);
  }

  hideFilesList() {
    this.$component.classList.add(this.#filesListClasName);
  }
}

export default () =>
  new DigitalAssetsUploadComponent({
    componentSelector: ".js-digital-assets-assets-upload-form"
  });
